import '../../css/index.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useState, useEffect,useContext } from "react";
import { konekcijaContext } from '../../../globalne/KonekcijaBaza';

function Rezultati() {
    const konekcija = useContext(konekcijaContext);
    const [tabela, setTabela] = useState<any>();

    const Rezultati_svi = async () => {

        fetch(konekcija+'rezultati', {
            method: 'POST', 
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
             
            })
           
          })
            .then(res => res.json())
            .then(data => {
               if(data !== ""){          
                   const tabele = <table>
                                        <thead>
                                            <tr>
                                                <th>Ime</th>
                                                <th>Pobede</th>
                                                <th>Porazi</th>
                                                <th>Najmanje poteza</th>
                                                <th>Najbrža partija</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data.map((item: any) => {
                                                return (
                                            <tr key={item.id_igraca}> 
                                                <td>{item.username}</td>  
                                                <td>{item.broj_pobeda}</td>  
                                                <td>{item.broj_poraza}</td>  
                                                <td>{item.najmanje_poteza}</td> 
                                                <td>{item.najbrza_pobeda}</td>
                                            </tr>
                                                )                           
                                            })}
                                        </tbody>
                                    </table>
                  
                  setTabela(tabele);             
                }
              
            })


    }    
    useEffect(() => { 
        Rezultati_svi();
      }, []);

   return(
    <div>{tabela}</div>
   )
}

export default Rezultati;